import React, { Dispatch, SetStateAction } from 'react';

import InfoInput from '~/components/Inputs/Info';
import TextArea from '~/components/TextArea';
import CloseButton from '~/components/Buttons/Close';

import {
  StyledModal,
  MainContainer,
  Title,
  Container,
  Content,
  ContentSplit,
  Wrapper,
  HalfWrapper,
  ButtonContainer,
} from './styles';

interface IRecordNoteDetailProps {
  isOpen: boolean;
  onClose: () => void;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  description: string;
  note: string;
  user: string;
  project_procedure_description: string;
}

const RecordNoteDetail: React.FC<IRecordNoteDetailProps> = ({
  isOpen,
  onClose,
  setIsOpen,
  description,
  note,
  user,
  project_procedure_description,
}: IRecordNoteDetailProps) => {
  const handleClose = (): void => {
    setIsOpen(false);
    onClose();
  };

  return (
    <StyledModal
      isOpen={isOpen}
      style={{
        overlay: {
          zIndex: 999,
          overflowY: 'auto',
          position: 'fixed',
          background: 'rgba(0, 0, 0, 0.5)',
        },
      }}
    >
      <MainContainer>
        <Title>Detalhes Observação</Title>
        <Container>
          <Content maxWidth="680px">
            <Wrapper>
              <InfoInput
                name="description"
                labelFor="description"
                labelText="Descrição"
                type="text"
                defaultValue={description}
                disabled
              />
            </Wrapper>
          </Content>

          <Content maxWidth="680px">
            <Wrapper>
              <TextArea
                name="note"
                labelFor="note"
                labelText="Observação"
                defaultValue={note}
                maxLength={1000}
                disabled
              />
            </Wrapper>
          </Content>

          <ContentSplit maxWidth="680px">
            <HalfWrapper marginRight="1rem">
              <InfoInput
                name="user"
                labelFor="user"
                labelText="Usuário"
                type="text"
                defaultValue={user}
                disabled
              />
            </HalfWrapper>

            <HalfWrapper>
              <InfoInput
                name="project_procedure_name"
                labelFor="project_procedure_name"
                labelText="Procedimento"
                type="text"
                defaultValue={project_procedure_description}
                disabled
              />
            </HalfWrapper>
          </ContentSplit>

          <ButtonContainer>
            <CloseButton onClick={() => handleClose()} />
          </ButtonContainer>
        </Container>
      </MainContainer>
    </StyledModal>
  );
};

export default RecordNoteDetail;
